export default "/static/tecan_evo_tiny.png";